import useCotFlow from "@custom-hooks/useCotFlow";
import { editorActions } from "@store/editor";
import { useDispatch } from "react-redux";
import { useReactFlow } from "reactflow";

export function useHomeCot() {
  const { setCenter } = useReactFlow();
  const dispatch = useDispatch();

  const setEnableTooltipWhatTodo = (val: any) => {
    dispatch(editorActions.setEnableTooltipWhatTodo(val));
  };

  const setShowTooltip = (val: any) => {
    dispatch(editorActions.setShowTooltip(val));
  };
  const { showAllInputs } = useCotFlow({
    setEnableTooltipWhatTodo,
    setShowTooltip,
    setCenter,
  });

  return { showAllInputs };
}
